import { TradeType } from './types'
import * as Yup from 'yup'

export const TradeFormValidationSchema = Yup.object().shape({
  type: Yup.mixed<TradeType>()
    .oneOf(Object.values(TradeType))
    .required('Please select a trade type'),
  card: Yup.string()
    .not(['0'], 'You must select a card')
    .required('You must select a card'),
  amount: Yup.number()
    .moreThan(0, 'Amount should be greater than 0')
    .required('Please provide an amount'),
  extraInfo: Yup.string(),
  file: Yup.mixed().nullable(),
  acceptTerms: Yup.boolean().isTrue('You must agree to our terms & conditions'),
})
